import asyncFetch from '../utils/asyncFetch';

export const getSubscription = async (token, user) => {
  try {
    const result = await asyncFetch(`${process.env.REACT_APP_BACKEND_URL}/subscription`, {
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
    });
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const requestInvoice = async ({ email, token }) => {
  try {
    const result = await asyncFetch(`${process.env.REACT_APP_BACKEND_URL}/subscription/request/paypal`, {
      method: 'POST',
      body: { email },
      headers: { Authorization: `Bearer ${token}` },
    });
    return result;
  } catch (error) {
    console.error(error);
  }
};
